import React from 'react'
import Image from 'next/image'
import { Header2, Text } from '../../styles/Components'
import Button from '../Button'
import { gsColors as c } from '../../styles/Variables'
import styled from '@emotion/styled'
import { mq } from '../../helpers'
import GroupImg from '../../../public/how-it-works/group.webp'

const GroupWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: row;

  ${mq('max', '768px')} {
    flex-direction: column;
  }

  .image-placeholder {
    width: 50%;
    position: relative;
    min-height: 509px;

    ${mq('max', '768px')} {
      width: 100%;
      min-height: 320px;
      order: 2;
    }
  }

  .content {
    width: 50%;
    background-color: ${c.khaki};
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 88px;

    ${mq('max', '1024px')} {
      padding: 44px;
    }

    ${mq('max', '768px')} {
      width: 100%;
      padding: 48px 16px;
      order: 1;
    }
  }
`

const GroupAffair = () => (
  <GroupWrapper>
    <div className="image-placeholder">
      <Image
        src={GroupImg}
        alt="Group of friends enjoying a Glamsquad group beauty session at home"
        fill
        sizes="(max-width: 768px) 100vw, 50vw"
        style={{ objectFit: 'cover' }}
      />
    </div>
    <div className="content">
      <Header2 margin="0 0 24px 0">Make it a group affair</Header2>
      <Text variant="small" lineHeight="145%" spacing={0.16}>
        There&apos;s nothing like bonding over beauty. Elevate your next
        pre-game or gathering with pampering glam for your whole crew. Our
        concierge team is at your service to customize your experience for
        personal or professional use.
      </Text>
      <Button large color={c.cobalt} path="/events" margin="24px 0 0 0">
        Book Group Glam
      </Button>
    </div>
  </GroupWrapper>
)

export default GroupAffair
